// Module
var code = "<div class=\"container\"><react-component name=\"NetRevenueGraphs\"></react-component></div>\n";
// Exports
module.exports = code;